import {createRouter, createWebHistory} from 'vue-router'
import { odistSubPerm, odistPathAccess, odistFirstAllowedPath } from '@/utils/odistPerm'
import { ODIST_LOGIN_PATH } from '@/config/odist-menus'

// 로그인이 풀렸을 때 보낼 로그인 화면 — odist 화면은 odist 로그인(마스터·매장·직원 다 받는다, 2026-10-29),
//   나머지는 예전 그대로 MYSHOP 로그인. 직원 아이디는 MYSHOP 로그인에서 안 되므로 odist 를 MYSHOP 으로 보내면 직원이 못 들어온다
function loginPageUrl(fullPath) {
    if (String(fullPath || '').startsWith('/admin/odist')) return ODIST_LOGIN_PATH + '?url=' + encodeURIComponent(fullPath)
    return process.env.VUE_APP_LOGIN_URL + '/user/login?url=' + encodeURIComponent(process.env.VUE_APP_ADMIN_URL + fullPath)
}
//import VueRouter from 'vue-router'
import store from "./store"
import axios from 'axios'

import NotFound from "./views/404.vue";
import { getSessionToken, isSessionExpired, touchSession, clearSession } from './sessionCookie.js';
import { ADMIN_TYPE, getAdminTypeFromPath } from './config/adminConfig.js';

// 보호 대상 경로 판별 함수
function needsExtraAuth(to) {
    // '/path' 및 하위 전부
    return to.path === '/master-admin' || to.path.startsWith('/master-admin/') ||
           to.path.startsWith('/admin/master/');
}

function checkFilter(path, session) {
    let ty1 = session.type1
    let ty2 = session.type2
    // '/path' 및 하위 전부
    if(path.indexOf('/master-admin/root') >= 0) {
        if(ty1 != 'ADMIN') {
            throw 'e'
        }
    }
}


const routes = [
    //path: '/',
    //component: DefaultLayout,
    //children: [
    {
        path: '/',
        redirect: '/admin',
    },
    {
        path: '/checkout/help',
        component: () => import('@/components/pages/checkout/help'),
    },
    {
        path: '/checkout/block',
        component: () => import('@/components/pages/checkout/block'),
    },
    {
        path: '/checkout/bridge',
        component: () => import('@/components/pages/checkout/bridge'),
    },
    {
        path: '/admin/e_mod_product',
        component: () => import('@/components/pages/prod/mod_product'),
    },
    {
        path: '/admin/e_mod_category',
        component: () => import('@/components/pages/prod/CategoryProductList.vue'),
    },
    {
        path: '/admin/menu',
        component: () => import('@/components/pages/menu'),
    },
    {
        path: '/admin/smart_order/detail',
        component: () => import('@/components/pages/smartorder/order'),
    },
    {
        path: '/admin/manager/member_mng',
        component: () => import('@/components/pages/manager/member_mng'),
    },
    {
        path: '/admin/manager/kiosk',
        component: () => import('@/components/pages/manager/kiosk'),
    },
    {
        path: '/admin/prod/list',
        component: () => import('@/components/pages/prod/list_parent_v2'),
    },
    {
        path: '/admin/prod/list-online',
        component: () => import('@/components/pages/prod/list_online'),
    },

    {
        path: '/admin/prod/list_admin_pos',
        component: () => import('@/components/pages/prod/list_admin_pos'),
    },
    {
        path: '/admin/prod/option_list',
        component: () => import('@/components/pages/prod/option_parent_v2'),
    },
    {
        path: '/admin/riders/members',
        component: () => import('@/components/pages/riders/members'),
    },
    {
        path: '/admin/riders/mshops',
        component: () => import('@/components/pages/riders/mshops'),
    },
    {
        path: '/admin/riders/points',
        component: () => import('@/components/pages/riders/points'),
    },
    {
        path: '/admin/rider-user/orders',
        component: () => import('@/components/pages/rider-user/orders'),
    },
    {
        path: '/admin/riders/orders',
        component: () => import('@/components/pages/riders/orders'),
    },
    {
        path: '/admin/riders/my_points',
        component: () => import('@/components/pages/riders/my_points'),
    },
    {
        path: '/admin/riders/map',
        component: () => import('@/components/pages/riders/map'),
    },
    {
        path: '/admin/prod/option_detail',
        component: () => import('@/components/pages/prod/option_parent_v2'),
    },
    {
        path: '/admin/prod/category_list',
        component: () => import('@/components/pages/prod/category_list_v2'),
    },
    {
        path: '/admin/erp/master',
        component: () => import('@/components/pages/erp/master_shops'),
    },
    {
        path: '/admin/erp/monthly_completion',
        component: () => import('@/components/pages/erp/monthly_completion.vue'),
    },
    {
        path: '/admin/erp/monthly_completion_report',
        component: () => import('@/components/pages/erp/monthly_completion_report.vue'),
    },
    {
        path: '/admin/erp/item_detail_report',
        component: () => import('@/components/pages/erp/item_detail_report.vue'),
    },
    {
        path: '/admin/erp/purchase_item_detail_report',
        component: () => import('@/components/pages/erp/purchase_item_detail_report.vue'),
    },

    {
        path: '/admin/myshop_info',
        component: () => import('@/components/pages/setting/myshop_info.vue'),
    },
    {
        path: '/admin/smartorder_info',
        component: () => import('@/components/common/SmartorderMainInfo.vue'),
    },

    {
        path: '/admin/sales_report/summary',
        component: () => import('@/components/pages/sales_report/summary.vue'),
    },
    {
        path: '/admin/sales_report/smartorder',
        component: () => import('@/components/pages/sales_report/smartorder.vue'),
    },
    {
        path: '/admin/sales_report/summary_calendar',
        component: () => import('@/components/pages/sales_report/summary_calendar.vue'),
    },
    {
        path: '/admin/sales_report/detail_report',
        component: () => import('@/components/pages/sales_report/detail_report.vue'),
    },
    {
        path: '/admin/sales_report/menu_report',
        component: () => import('@/components/pages/sales_report/menu_report.vue'),
    },

    {
        path: '/admin/sales_report/menu_type_report',
        component: () => import('@/components/pages/sales_report/menu_type_report.vue'),
    },
    {
        path: '/admin/sales_report/menu_payment_report',
        component: () => import('@/components/pages/sales_report/menu_payment_report.vue'),
    },
    {
        path: '/admin/sales_report/region_report',
        component: () => import('@/components/pages/sales_report/region_report.vue'),
    },
    {
        path: '/admin/sales_report/timing_report',
        component: () => import('@/components/pages/sales_report/timing_report.vue'),
    },
    {
        path: '/admin/sales_report/daily_report',
        component: () => import('@/components/pages/sales_report/daily_report.vue'),
    },
    {
        path: '/admin/sales_report/daily_completion_report',
        component: () => import('@/components/pages/sales_report/daily_completion_report.vue'),
    },
    {
        path: '/admin/sales_report/guest_sales_report',
        component: () => import('@/components/pages/sales_report/guest_sales_report.vue'),
    },
    {
        path: '/admin/sales_report/payment_sales_report',
        component: () => import('@/components/pages/sales_report/payment_sales_report.vue'),
    },
    {
        path: '/admin/sales_report/discount_detail_report',
        component: () => import('@/components/pages/sales_report/discount_detail_report.vue'),
    },
    {
        path: '/admin/sales_report/payment_detail_report',
        component: () => import('@/components/pages/sales_report/payment_detail_report.vue'),
    },
    {
        path: '/admin/sales_report/event_coupon_report',
        component: () => import('@/components/pages/sales_report/event_coupon_report.vue'),
    },
    {
        path: '/admin/sales_report/event_coupon_detail_report',
        component: () => import('@/components/pages/sales_report/event_coupon_detail_report.vue'),
    },
    {
        path: '/admin/sales_report/branch_sales',
        component: () => import('@/components/pages/sales_report/branch_sales.vue'),
    },
    {
        path: '/admin/sales_report/branch_sales2',
        component: () => import('@/components/pages/sales_report/branch_sales2.vue'),
    },
    {
        path: '/admin/sales_report/yearly_sales',
        component: () => import('@/components/pages/sales_report/yearly_sales.vue'),
    },
    {
        path: '/admin/sales_report/monthly_sales',
        component: () => import('@/components/pages/sales_report/monthly_sales.vue'),
    },
    {
        path: '/admin/sales_report/period_sales',
        component: () => import('@/components/pages/sales_report/period_sales.vue'),
    },
    {
        path: '/admin/sales_report/user_list',
        component: () => import('@/components/pages/sales_report/user_list.vue'),
    },
    {
        path: '/admin/sales_report/marketing',
        component: () => import('@/components/pages/sales_report/marketing.vue'),
    },
    {
        path: '/admin/sales_report/hourly_sales',
        component: () => import('@/components/pages/sales_report/hourly_sales.vue'),
    },
    {
        path: '/admin/sales_report/sales_by_product',
        component: () => import('@/components/pages/sales_report/sales_by_product.vue'),
    },
    {
        path: '/admin/sales_report/daily_sales',
        component: () => import('@/components/pages/sales_report/daily_sales.vue'),
    },
    {
        path: '/admin/sales_report/postpaid',
        component: () => import('@/components/pages/sales_report/postpaid.vue'),
    },

    {
        path: '/admin/erp/purchase_report1',
        component: () => import('@/components/pages/erp/purchase_report1.vue'),
    },
    {
        path: '/admin/erp/purchase_report2',
        component: () => import('@/components/pages/erp/purchase_report2.vue'),
    },
    {
        path: '/admin/erp/master_order_list',
        component: () => import('@/components/pages/erp/master_order_list.vue'),
    },
    {
        path: '/admin/erp/giftcard_list',
        component: () => import('@/components/pages/erp/giftcard_list.vue'),
    },
    {
        path: '/admin/erp/notification_log',
        component: () => import('@/components/pages/erp/notification_log.vue'),
    },

    {
        path: '/admin/erp/monthly_item_report',
        component: () => import('@/components/pages/erp/monthly_item_report'),
    },
    {
        path: '/admin/erp/monthly_item_dd',
        component: () => import('@/components/pages/erp/monthly_item_dd'),
    },

    {
        path: '/admin/erp/new_sale',
        component: () => import('@/components/pages/erp/new_sale'),
    },
    {
        path: '/admin/erp/new_set_product',
        component: () => import('@/components/pages/erp/new_set_product'),
    },
    {
        path: '/admin/erp/set_product_list',
        component: () => import('@/components/pages/erp/set_product_list'),
    },
    {
        path: '/admin/erp/new_promotion_product',
        component: () => import('@/components/pages/erp/new_promotion_product'),
    },
    {
        path: '/admin/erp/promotion_product_list',
        component: () => import('@/components/pages/erp/promotion_product_list'),
    },
    {
        path: '/admin/erp/sale_product_list',
        component: () => import('@/components/pages/erp/sale_product_list'),
    },

    {
        path: '/admin/erp/item_list',
        component: () => import('@/components/pages/erp/item_list'),
    },
    {
        path: '/admin/erp/item_list_shop',
        component: () => import('@/components/pages/erp/item_list_shop'),
    },
    {
        path: '/admin/erp/item_history',
        component: () => import('@/components/pages/erp/item_history'),
    },
    {
        path: '/admin/erp/item_status',
        component: () => import('@/components/pages/erp/item_status'),
    },
    {
        path: '/admin/erp/item_xls',
        component: () => import('@/components/pages/erp/item_xls'),
    },
    {
        path: '/admin/erp/vendor_list',
        component: () => import('@/components/pages/erp/vendor_list'),
    },
    {
        path: '/admin/erp/category_list',
        //component: () => import('@/components/pages/erp/vendor_category_list'),
        component: () => import('@/components/pages/erp/category_list'),
    },
    {
        path: '/admin/erp/prod_list',
        //component: () => import('@/components/pages/erp/vendor_category_list'),
        component: () => import('@/components/pages/erp/prod_list'),
    },
    {
        path: '/admin/erp/order',
        component: () => import('@/components/pages/erp/order.vue'),
    },
    {
        path: '/admin/erp/order_detail',
        component: () => import('@/components/pages/erp/order_detail.vue'),
    },
    {
        path: '/admin/erp/mimibax_order',
        component: () => import('@/components/pages/erp/mimibax_order.vue'),
    },
    {
        path: '/admin/erp/mimiline_categories',
        component: () => import('@/components/pages/erp/mimiline_categories.vue'),
    },
    {
        path: '/admin/erp/product_list1',
        component: () => import('@/components/pages/erp/product_list1.vue'),
    },
    {
        path: '/admin/erp/product_list2',
        component: () => import('@/components/pages/erp/product_list2.vue'),
    },
    {
        path: '/admin/erp/product_add',
        component: () => import('@/components/pages/erp/product_add.vue'),
    },
    {
        path: '/admin/erp/vendor_management',
        component: () => import('@/components/pages/erp/vendor_management.vue'),
    },
    {
        path: '/admin/erp/confirm_order',
        component: () => import('@/components/pages/erp/confirm_order.vue'),
    },
    {
        path: '/admin/erp/confirm_order_midas',
        component: () => import('@/components/pages/erp/confirm_order_midas.vue'),
    },
    {
        path: '/admin/erp/order_list',
        component: () => import('@/components/pages/erp/order_list.vue'),
    },
    {
        path: '/admin/erp/order_list2',
        component: () => import('@/components/pages/erp/order_list2.vue'),
    },
    {
        path: '/admin/erp/settlement_list',
        component: () => import('@/components/pages/erp/settlement_list.vue'),
    },
    {
        path: '/admin/erp/settlement_detail',
        component: () => import('@/components/pages/erp/settlement_detail.vue'),
    },
    {
        path: '/admin/erp/settlement_list_master',
        component: () => import('@/components/pages/erp/settlement_list_master.vue'),
    },
    {
        path: '/admin/erp/storing',
        component: () => import('@/components/pages/erp/storing.vue'),
    },
    {
        path: '/erp/inventory-counts',
        component: () => import('@/components/pages/erp/InventoryCountList.vue'),
    },
    {
        path: '/erp/inventory-count/create',
        component: () => import('@/components/pages/erp/InventoryCountCreate.vue'),
    },
    {
        path: '/erp/inventory-count/:id',
        component: () => import('@/components/pages/erp/InventoryCountDetail.vue'),
    },
    {
        path: '/erp/warehouses',
        component: () => import('@/components/pages/erp/WarehouseSettings.vue'),
    },
    {
        path: '/erp/warehouse-boxes',
        component: () => import('@/components/pages/erp/WarehouseBoxList.vue'),
    },
    {
        path: '/erp/warehouse-box/create',
        component: () => import('@/components/pages/erp/WarehouseBoxCreate.vue'),
    },
    {
        path: '/erp/warehouse-box/:id',
        component: () => import('@/components/pages/erp/WarehouseBoxDetail.vue'),
    },
    {
        path: '/erp/sub-user',
        component: () => import('@/components/pages/erp/sub_user.vue'),
    },
    {
        path: '/admin/erp/sub-user',
        component: () => import('@/components/pages/erp/sub_user.vue'),
    },

    // ODIST (미미라인 전용) 라우트
    {
        // 계정 종류(마스터/매장)를 판별해 각자의 첫 메뉴로 보내는 진입 페이지.
        // redirect 는 가드보다 먼저 평가돼 계정 정보를 모르므로 컴포넌트로 처리한다.
        path: '/admin/odist',
        component: () => import('@/components/pages/odist/odist_home.vue'),
    },
    {
        path: '/admin/odist/vendor_management',
        component: () => import('@/components/pages/odist/vendor_management.vue'),
    },
    {
        path: '/admin/odist/category_management',
        component: () => import('@/components/pages/odist/category_management.vue'),
    },
    {
        path: '/admin/odist/option_management',
        component: () => import('@/components/pages/odist/OptionManagement.vue'),
    },
    {
        path: '/admin/odist/item_list',
        component: () => import('@/components/pages/odist/item_list.vue'),
    },
    {
        path: '/admin/odist/item_register',
        component: () => import('@/components/pages/odist/ItemRegister.vue'),
    },
    {
        path: '/admin/odist/item_combo_register',
        component: () => import('@/components/pages/odist/ItemComboRegister.vue'),
    },
    {
        path: '/admin/odist/item_image_upload',
        component: () => import('@/components/pages/odist/ItemImageUpload.vue'),
    },
    {
        path: '/admin/odist/item_paste_register',
        component: () => import('@/components/pages/odist/ItemPasteRegister.vue'),
    },
    {
        path: '/admin/odist/item_migrate_register',
        component: () => import('@/components/pages/odist/ItemMigrateRegister.vue'),
    },
    {
        path: '/admin/odist/item_attr_upload',
        component: () => import('@/components/pages/odist/item_attr_upload.vue'),
    },
    {
        path: '/admin/odist/store_item_search',
        component: () => import('@/components/pages/odist/store_item_search.vue'),
    },
    {
        path: '/admin/odist/item_block',
        component: () => import('@/components/pages/odist/item_block.vue'),
    },
    {
        path: '/admin/odist/item_tag',
        component: () => import('@/components/pages/odist/item_tag.vue'),
    },
    {
        path: '/admin/odist/location_shelf',
        component: () => import('@/components/pages/odist/location_shelf.vue'),
    },
    {
        path: '/admin/odist/location_assign',
        component: () => import('@/components/pages/odist/location_assign.vue'),
    },
    {
        path: '/admin/odist/location_planogram',
        component: () => import('@/components/pages/odist/location_planogram.vue'),
    },
    {
        // 조회 전용(편집 모드 없음). 같은 컴포넌트를 viewOnly prop으로 재사용.
        path: '/admin/odist/location_planogram_view',
        component: () => import('@/components/pages/odist/location_planogram.vue'),
        props: { viewOnly: true },
    },
    {
        // 매장 층별 도면(플로어 플랜) — 로케이션의 상위 개념(도면 > 블록 > 진열대 > 칸).
        // 메뉴 키 floor_plan (config/odist-menus.js, 로케이션 관리 그룹).
        // 조회 전용(_view)은 메뉴에서 뺐고 alias 로만 연결돼 있다 — 직접 URL 로는 열린다.
        path: '/admin/odist/location_floorplan',
        component: () => import('@/components/pages/odist/location_floorplan.vue'),
    },
    {
        // 조회 전용(편집 모드 없음). 같은 컴포넌트를 viewOnly prop 으로 재사용.
        path: '/admin/odist/location_floorplan_view',
        component: () => import('@/components/pages/odist/location_floorplan.vue'),
        props: { viewOnly: true },
    },
    {
        // 로케이션 기반 발주 — 도면에서 진열대를 골라 그 자리 상품을 발주.
        // 메뉴 키 location_order (config/odist-menus.js, '발주 및 입고' 그룹 맨 위).
        path: '/admin/odist/location_order',
        component: () => import('@/components/pages/odist/location_order.vue'),
    },
    {
        // 발주 계획 — 전 품목 목록에서 추천수량을 보고 외부 발주할 물량을 정한다.
        // 🔑로케이션 발주와 계산 엔진은 같고 **입구만 다르다**(진열대가 아니라 전체 목록).
        //   케뷰는 도면·진열대가 0건이라 로케이션 입구를 쓸 수 없다.
        path: '/admin/odist/order_plan',
        component: () => import('@/components/pages/odist/order_plan.vue'),
    },
    {
        // 발주 계획서 — 확정·거래처별 조회·인쇄·엑셀. 사전입고가 이 계획서를 물어간다.
        path: '/admin/odist/order_plan_list',
        component: () => import('@/components/pages/odist/order_plan_list.vue'),
    },
    {
        path: '/admin/odist/order',
        component: () => import('@/components/pages/odist/order.vue'),
    },
    {
        path: '/admin/odist/order_list',
        component: () => import('@/components/pages/odist/order_list.vue'),
    },
    {
        path: '/admin/odist/order_detail',
        component: () => import('@/components/pages/odist/order_detail.vue'),
    },
    {
        path: '/admin/odist/confirm_order',
        component: () => import('@/components/pages/odist/confirm_order.vue'),
    },
    {
        path: '/admin/odist/pre_receipt',
        component: () => import('@/components/pages/odist/pre_receipt.vue'),
    },
    {
        path: '/admin/odist/pre_receipt_settle',
        component: () => import('@/components/pages/odist/pre_receipt_settle.vue'),
    },
    {
        path: '/admin/odist/receipt_lines',
        component: () => import('@/components/pages/odist/receipt_lines.vue'),
    },
    {
        path: '/admin/odist/promo_goods',
        component: () => import('@/components/pages/odist/promo_goods.vue'),
    },
    {
        path: '/admin/odist/sales_compare',
        component: () => import('@/components/pages/odist/sales_compare.vue'),
    },
    {
        path: '/admin/odist/sales_breakdown',
        component: () => import('@/components/pages/odist/sales_breakdown.vue'),
    },
    {
        path: '/admin/odist/price_history',
        component: () => import('@/components/pages/odist/price_history.vue'),
    },
    {
        path: '/admin/odist/stock_transfer',
        component: () => import('@/components/pages/odist/stock_transfer.vue'),
    },
    {
        path: '/admin/odist/pack_map',
        component: () => import('@/components/pages/odist/pack_map.vue'),
    },
    {
        path: '/admin/odist/barcode_link',
        component: () => import('@/components/pages/odist/barcode_link.vue'),
    },
    {
        path: '/admin/odist/set_product',
        component: () => import('@/components/pages/odist/set_product.vue'),
    },
    {
        path: '/admin/odist/set_sales',
        component: () => import('@/components/pages/odist/set_sales.vue'),
    },
    {
        path: '/admin/odist/promotion',
        component: () => import('@/components/pages/odist/promotion.vue'),
    },
    // 구 경로(박스 개봉/재포장) — 즐겨찾기·기존 링크가 죽지 않게 새 화면으로 넘긴다.
    {
        path: '/admin/odist/pack_convert',
        redirect: '/admin/odist/pack_map',
    },
    {
        path: '/admin/odist/pos_sales_upload',
        component: () => import('@/components/pages/odist/pos_sales_upload.vue'),
    },
    {
        path: '/admin/odist/stock_overwrite',
        component: () => import('@/components/pages/odist/stock_overwrite.vue'),
    },
    {
        path: '/admin/odist/pos_sales_analysis',
        component: () => import('@/components/pages/odist/pos_sales_analysis.vue'),
    },
    // odist 판매 리포트.
    //
    // 화면은 /admin/sales_report/* 와 같은 컴포넌트를 그대로 쓴다. 경로만 다른
    // 이유는 두 가지다: (1) 경로에 /odist 가 있어야 사이드바가 odist 메뉴로
    // 유지된다, (2) 컴포넌트가 경로를 보고 npos-api(샤드)로 붙는다.
    // salesReportApi.js 참고.
    {
        path: '/admin/odist/sales_report/daily_sales',
        component: () => import('@/components/pages/sales_report/daily_sales.vue'),
    },
    {
        path: '/admin/odist/sales_report/summary',
        component: () => import('@/components/pages/sales_report/summary.vue'),
    },
    {
        path: '/admin/odist/sales_report/summary_calendar',
        component: () => import('@/components/pages/sales_report/summary_calendar.vue'),
    },
    {
        path: '/admin/odist/sales_report/monthly_sales',
        component: () => import('@/components/pages/sales_report/monthly_sales.vue'),
    },
    {
        path: '/admin/odist/sales_report/period_sales',
        component: () => import('@/components/pages/sales_report/period_sales.vue'),
    },
    {
        path: '/admin/odist/sales_report/sales_by_product',
        component: () => import('@/components/pages/sales_report/sales_by_product.vue'),
    },
    {
        path: '/admin/odist/sales_report/yearly_sales',
        component: () => import('@/components/pages/sales_report/yearly_sales.vue'),
    },
    {
        path: '/admin/odist/sales_report/hourly_sales',
        component: () => import('@/components/pages/sales_report/hourly_sales.vue'),
    },
    {
        path: '/admin/odist/sales_report/tax_refund',
        component: () => import('@/components/pages/sales_report/tax_refund.vue'),
    },
    {
        path: '/admin/odist/sales_report/tax_refund_products',
        component: () => import('@/components/pages/sales_report/tax_refund_products.vue'),
    },
    {
        path: '/admin/odist/sales_report/branch_sales',
        component: () => import('@/components/pages/sales_report/branch_sales.vue'),
    },
    {
        path: '/admin/odist/sales_report/branch_sales2',
        component: () => import('@/components/pages/sales_report/branch_sales2.vue'),
    },
    {
        path: '/admin/odist/stock_status',
        component: () => import('@/components/pages/odist/stock_status.vue'),
    },
    {
        path: '/admin/odist/item_history',
        component: () => import('@/components/pages/odist/item_history.vue'),
    },
    {
        path: '/admin/odist/sales_analysis',
        component: () => import('@/components/pages/odist/sales_analysis.vue'),
    },
    {
        path: '/admin/odist/biox_sales_settle',
        component: () => import('@/components/pages/odist/biox_sales_settle.vue'),
    },
    {
        path: '/admin/odist/biox_orders',
        component: () => import('@/components/pages/odist/biox_orders.vue'),
    },
    {
        path: '/admin/odist/biox_settlement',
        component: () => import('@/components/pages/odist/biox_settlement.vue'),
    },
    {
        path: '/admin/odist/settlement',
        component: () => import('@/components/pages/odist/settlement.vue'),
    },
    {
        // 마스터 전용: 직원 계정 관리 / 역할(권한) 관리. 서브계정은 가드(odistPathAccess)가 막는다.
        path: '/admin/odist/sub_account',
        component: () => import('@/components/pages/odist/sub_account.vue'),
    },
    {
        path: '/admin/odist/role_management',
        component: () => import('@/components/pages/odist/role_management.vue'),
    },
    {
        path: '/admin/odist/return',
        component: () => import('@/components/pages/odist/return_management.vue'),
    },
    {
        path: '/admin/odist/inventory_adjust',
        component: () => import('@/components/pages/odist/inventory_adjust.vue'),
    },
    {
        path: '/admin/odist/disposal',
        component: () => import('@/components/pages/odist/disposal.vue'),
    },
    {
        path: '/admin/odist/as_request',
        component: () => import('@/components/pages/odist/as_request.vue'),
    },
    {
        path: '/admin/odist/as_receive',
        component: () => import('@/components/pages/odist/as_receive.vue'),
    },

    {
        path: '/admin/setting/account_list',
        component: () => import('@/components/pages/setting/account_list'),
    },
    {
        path: '/admin/setting/request_service',
        component: () => import('@/components/pages/setting/request_service'),
    },
    {
        path: '/admin/master/check_request',
        component: () => import('@/components/pages/master/check_request'),
    },
    // MYSHOP Master 관리 페이지 (IP 제한 적용)
    {
        path: '/admin/master/shop_info_requests',
        component: () => import('@/components/pages/master/shop_info_requests.vue'),
    },
    {
        path: '/admin/master/shop_info_request_detail',
        component: () => import('@/components/pages/master/shop_info_request_detail.vue'),
    },
    {
        path: '/admin/master/confirm_user_corp',
        component: () => import('@/components/pages/master/confirm_user_corp.vue'),
    },
    {
        path: '/admin/master/confirm_user_corp_detail',
        component: () => import('@/components/pages/master/confirm_user_corp_detail.vue'),
    },
    {
        path: '/admin/master/confirm_myshop',
        component: () => import('@/components/pages/master/confirm_myshop.vue'),
    },
    {
        path: '/admin/master/confirm_myshop_detail',
        component: () => import('@/components/pages/master/confirm_myshop_detail.vue'),
    },
    {
        path: '/admin/master/mshop_list',
        component: () => import('@/components/pages/master/mshop_list.vue'),
    },
    {
        path: '/admin/master/member_list',
        component: () => import('@/components/pages/master/member_list.vue'),
    },
    {
        path: '/admin/master/order_finalized',
        component: () => import('@/components/pages/master/order_finalized.vue'),
    },
    {
        path: '/admin/master/unified_refund',
        component: () => import('@/components/pages/master/unified_refund.vue'),
    },
    {
        path: '/admin/master/settled_deduct',
        component: () => import('@/components/pages/master/settled_deduct.vue'),
    },
    {
        path: '/admin/master/exceptional_refund',
        component: () => import('@/components/pages/master/exceptional_refund.vue'),
    },
    {
        path: '/admin/master/partial_refund',
        component: () => import('@/components/pages/master/partial_refund.vue'),
    },
    {
        path: '/admin/master/user_partial_refund_done',
        component: () => import('@/components/pages/master/user_partial_refund_done.vue'),
    },
    {
        path: '/admin/master/exceptional_adjustment',
        component: () => import('@/components/pages/master/exceptional_adjustment.vue'),
    },
    {
        path: '/admin/master/confirm_refund_cash',
        component: () => import('@/components/pages/master/confirm_refund_cash.vue'),
    },
    {
        path: '/admin/master/invite_email',
        component: () => import('@/components/pages/master/invite_email.vue'),
    },
    {
        path: '/admin/login',
        component: () => import('@/components/pages/user/login_admin'),
    },
    {
        path: '/user/simple/login',
        component: () => import('@/components/pages/user/login_simple'),
    },
    {
        path: '/user/phone/login',
        component: () => import('@/components/pages/user/login_phone'),
    },
    {
        path: '/user/join_v2',
        component: () => import('@/components/pages/user/join_v2'),
    },
    {
        path: '/user/forget',
        component: () => import('@/components/pages/user/forget'),
    },
    {
        path: '/user/from_domaemae',
        component: () => import('@/components/pages/user/from_domaemae'),
    },
    {
        path: '/user/from_init',
        component: () => import('@/components/pages/user/from_init'),
    },
    // 시작하기(계정+마이샵만) / 판매 시작하기(본인인증·사업자 인증·나이스페이 — 관리자 메인에서 옴)
    {
        path: '/user/start',
        component: () => import('@/components/pages/user/start'),
    },
    {
        path: '/user/sell',
        component: () => import('@/components/pages/user/sell'),
    },
    // 판매 가이드(네이버쇼핑·인스타그램 쇼핑 입점) — 예전 외부 문서 대신 우리 화면
    {
        path: '/user/guide/:topic',
        component: () => import('@/components/pages/user/guide'),
    },
    {
        path: '/user/auth',
        component: () => import('@/components/pages/user/auth'),
    },
    {
        path: '/user/auth_email',
        component: () => import('@/components/pages/user/auth_email'),
    },
    {
        path: '/user/auth_out',
        component: () => import('@/components/pages/user/auth_out'),
    },
    {
        path: '/b2b/login',
        component: () => import('@/components/pages/b2b/user/login_admin'),
    },
    {
        path: '/b2b/user/list',
        component: () => import('@/components/pages/b2b/user/list'),
    },
    {
        path: '/b2b/user/level',
        component: () => import('@/components/pages/b2b/user/level'),
    },
    {
        path: '/b2b/product/list',
        component: () => import('@/components/pages/b2b/product/list'),
    },
    {
        path: '/b2b/product/subList',
        component: () => import('@/components/pages/b2b/product/subList'),
    },
    /*
    {
        path: '/admin/tmp/list',
        component: () => import('@/components/pages/prod/category_list'),
    },
    {
        path: '/admin/tmp/list2',
        component: () => import('@/components/dialog/CategoryTree'),
    },
     */
    {
        path: '/admin/lang/update-contents',
        component: () => import('@/components/pages/lang/update_contents'),
    },
    {
        path: '/admin/lang/ai-update-contents',
        component: () => import('@/components/pages/lang/ai_update_contents'),
    },
    {
        path: '/admin/design/set-color',
        component: () => import('@/components/pages/design/set_color'),
    },

    {
        path: '/admin/billing/card-list',
        component: () => import('@/components/pages/billing/card_list'),
    },
    {
        path: '/admin/billing/payment-list',
        component: () => import('@/components/pages/billing/payment_list'),
    },
    {
        path: '/admin/marketing/msg',
        component: () => import('@/components/pages/marketing/msg'),
    },
    {
        path: '/user/reset-pass',
        component: () => import('@/components/pages/madmin/reset_pass'),
    },
    {
        path: '/user/master-login',
        component: () => import('@/components/pages/madmin/login'),
    },
    {
        path: '/sub-login',
        component: () => import('@/components/pages/user/login_sub.vue'),
    },
    {
        // odist 직원(서브)계정 전용 로그인. 라우터 가드의 공개 경로 목록에도 들어 있다.
        path: '/odist/login',
        component: () => import('@/components/pages/user/login_odist.vue'),
    },
    {
        path: '/master-admin/offline_account_mng',
        component: () => import('@/components/pages/madmin/offline_account_mng'),
    },
    {
        path: '/master-admin/delivery_account_mng',
        component: () => import('@/components/pages/madmin/delivery_account_mng'),
    },
    {
        path: '/master-admin/payment-monthly-detail',
        component: () => import('@/components/pages/billing/payment_monthly_detail'),
    },
    {
        path: '/master-admin/payment-user-detail',
        component: () => import('@/components/pages/billing/payment_user_detail'),
    },
    {
        path: '/admin/billing/payment-management-list',
        component: () => import('@/components/pages/billing/payment_management_list'),
    },
    {
        path: '/admin/billing/credit-management-list',
        component: () => import('@/components/pages/billing/user_credit_detail.vue'),
    },
    {
        path: '/master-admin/billing/payment-embed-list',
        component: () => import('@/components/pages/billing/payment_embed_list'),
    },
    {
        path: '/master-admin/billing/payment-list2',
        component: () => import('@/components/pages/billing/payment_list2.vue'),
    },
    {
        path: '/master-admin/billing/seller-embed-list',
        component: () => import('@/components/pages/billing/seller_embed_list'),
    },
    {
        path: '/master-admin/billing/seller-embed-list2',
        component: () => import('@/components/pages/billing/seller_embed_list2'),
    },
    {
        path: '/master-admin/billing/domaemae-pg',
        component: () => import('@/components/pages/billing/domaemae_pg'),
    },
    {
        path: '/master-admin/billing/nice-pg',
        component: () => import('@/components/pages/billing/default_pg'),
    },
    {
        path: '/master-admin/root/members',
        component: () => import('@/components/pages/madmin/root_members'),
    },
    {
        path: '/master-admin/mshops',
        component: () => import('@/components/pages/madmin/mshops'),
    },
    {
        path: '/master-admin/musers',
        component: () => import('@/components/pages/madmin/users'),
    },
    {
        path: '/master-admin/root/access_logs',
        component: () => import('@/components/pages/madmin/root_access_logs'),
    },
    {
        path: '/master-admin/root/member_logs',
        component: () => import('@/components/pages/madmin/root_member_logs'),
    },
    {
        path: '/master-admin/root/geo_access_logs',
        component: () => import('@/components/pages/madmin/root_geo_access_logs'),
    },
    {
        path: '/table/grid',
        component: () => import('@/components/pages/table/grid'),
    },
    {
        path: '/admin/prod/write_notice',
        component: () => import('@/components/pages/prod/write_notice.vue'),
    },
    {
        path: '/admin/prod/notice_list',
        component: () => import('@/components/pages/prod/notice_list.vue'),
    },
    {
        path: '/admin/prod/offline_menu_xls',
        component: () => import('@/components/pages/prod/offline_menu_xls'),
    },
    {
        path: '/admin/prod/offline_xls',
        component: () => import('@/components/pages/prod/offline_xls'),
    },
    {
        path: '/admin/store/customer_requests',
        component: () => import('@/components/pages/store/customer_requests'),
    },
    {
        path: '/admin/images/upload',
        component: () => import('@/components/pages/images/upload'),
    },
    {
        path: '/admin/images/list',
        component: () => import('@/components/pages/images/list'),
    },
    {
        path: '/admin/prod/online_xls',
        component: () => import('@/components/pages/prod/online_xls'),
    },
    {
        path: '/admin/manager/domae_api',
        component: () => import('@/components/pages/manager/domae_api'),
    },
    {
        path: '/admin/prod/online_xls_update',
        component: () => import('@/components/pages/prod/online_xls_update'),
    },
    {
        path: '/embed/members_list',
        component: () => import('@/components/pages/embed/members_list'),
    },
    {
        path: '/_embed/notice_view',
        component: () => import('@/components/pages/embed/notice_view'),
    },
    {
        path: '/_embed/agreement',
        component: () => import('@/components/pages/embed/agreement'),
    },
    {
        path: '/_embed/config_manager',
        component: () => import('@/components/pages/embed/config_manager'),
    },
    {
        path: '/_embed/privacy',
        component: () => import('@/components/pages/embed/privacy'),
    },
    {
        path: '/_embed/privacy2',
        component: () => import('@/components/pages/embed/privacy2'),
    },
    {
        path: '/_embed/order_report',
        component: () => import('@/components/pages/erp/order_report'),
    },
    {
        path: '/_embed/settlement_report',
        component: () => import('@/components/pages/odist/settlement_report'),
    },

    /*
    */
    {
        path: '/ext/qro_review',
        //component: () => import('@/components/pages/prod/list_parent_v2.vue'),
        component: () => import('@/components/pages/embed/qd_review.vue'),
    },
    {
        path: '/ext/prod_list',
        //component: () => import('@/components/pages/prod/list_parent_v2.vue'),
        component: () => import('@/components/pages/prod/ext_parent_v2.vue'),
    },
    {
        path: '/admin/e_prod_list',
        //component: () => import('@/components/pages/prod/list_parent_v2.vue'),
        component: () => import('@/components/pages/prod/ext_parent_v2.vue'),
    },
    {
        path: '/ext/erp',
        //component: () => import('@/components/pages/prod/list_parent_v2.vue'),
        component: () => import('@/components/pages/erp/master.vue'),
    },

    {
        path: '/ext/category_list',
        //component: () => import('@/components/pages/prod/category_list_v2.vue'),
        component: () => import('@/components/pages/prod/ext_parent_v2.vue'),
    },
    {
        path: '/ext/option_list',
        //component: () => import('@/components/pages/prod/option_parent_v2.vue'),
        component: () => import('@/components/pages/prod/ext_parent_v2.vue'),
    },

    {
        path: '/ext/option_detail',
        component: () => import('@/components/pages/prod/option_parent_v2.vue'),
    },

    // ============================================
    // MYSHOP 관리자 페이지 라우트
    // ============================================
    {
        path: '/myshop',
        component: () => import('@/components/pages/myshop/index.vue'),
    },
    // 판매자 글 번역 보기·고치기(글로벌 판매) — 마이샵 첫 화면 글로벌 판매 블록에서 들어온다
    {
        path: '/myshop/i18n',
        component: () => import('@/components/pages/myshop/i18n.vue'),
    },
    // 판매자 매뉴얼 — 인스타그램 앱에서 '메시지 접근 허용' 켜기(연결 화면에서 링크). 탭 틀 밖(혼자 보는 안내)
    {
        path: '/myshop/instagram/guide',
        component: () => import('@/components/pages/myshop/instagram_guide.vue'),
    },
    // SNS 판매 자동화 — 탭 틀(SnsShell) 하나 안에서 화면만 바뀐다(주소는 그대로). meta.shell 이면 App.vue router-view 가 틀을 다시 그리지 않는다.
    //  개요·자동화·콘텐츠 성과·발송 기록 = social-api /core-api/social/instagram (rules·stats·deliveries)
    //  영상 게시 = /core-api/social/publish, 인스타 연결 = 인스타 연결 뒤 돌아오는 곳(spring.social.instagram.admin_return), 유튜브 연결 = 구글에서 돌아오는 곳(spring.social.youtube.admin_return)
    {
        path: '/myshop/sns',
        redirect: '/myshop/social',
        component: () => import('@/components/pages/myshop/social/module/SnsShell.vue'),
        meta: { shell: 'sns' },
        children: [
            { path: '/myshop/social', component: () => import('@/components/pages/myshop/social/overview.vue'), meta: { title: 'SNS 판매 자동화' } },
            { path: '/myshop/social/rules', component: () => import('@/components/pages/myshop/social/rules.vue'), meta: { title: '자동화' } },
            { path: '/myshop/social/posts', component: () => import('@/components/pages/myshop/social/posts.vue'), meta: { title: '인스타 게시물' } },
            { path: '/myshop/social/groupbuy', component: () => import('@/components/pages/myshop/social/groupbuy.vue'), meta: { title: '인스타 공구' } },
            { path: '/myshop/social/content', component: () => import('@/components/pages/myshop/social/content.vue'), meta: { title: '콘텐츠 성과' } },
            { path: '/myshop/social/deliveries', component: () => import('@/components/pages/myshop/social/deliveries.vue'), meta: { title: '발송 기록' } },
            { path: '/myshop/social/publish', component: () => import('@/components/pages/myshop/social/publish.vue'), meta: { title: '영상 게시' } },
            { path: '/myshop/instagram', component: () => import('@/components/pages/myshop/instagram.vue'), meta: { title: '인스타그램 연결' } },
            { path: '/myshop/youtube', component: () => import('@/components/pages/myshop/youtube.vue'), meta: { title: '유튜브 연결' } },
        ]
    },
    // 파트너 판매(픽 대체 — 링크 귀속·장부) — Java /api/shopadm/partner/*
    {
        path: '/myshop/partner/setting',
        component: () => import('@/components/pages/myshop/partner/setting.vue'),
    },
    {
        path: '/myshop/partner/list',
        component: () => import('@/components/pages/myshop/partner/list.vue'),
    },
    // 상품별 요율(2차) — GET product_rates · POST product_rate. 우선순위 파트너 개별 > 상품 > 샵 기본
    {
        path: '/myshop/partner/products',
        component: () => import('@/components/pages/myshop/partner/products.vue'),
    },
    {
        path: '/myshop/partner/ledger',
        component: () => import('@/components/pages/myshop/partner/ledger.vue'),
    },
    // 상품 관리
    {
        path: '/myshop/product/list',
        component: () => import('@/components/pages/myshop/product/list.vue'),
    },
    {
        path: '/myshop/product/create',
        component: () => import('@/components/pages/myshop/product/create.vue'),
    },
    {
        path: '/myshop/product/category-list',
        component: () => import('@/components/pages/myshop/product/category_list.vue'),
    },
    {
        path: '/myshop/product/option-list',
        component: () => import('@/components/pages/myshop/product/option_list.vue'),
    },
    {
        path: '/myshop/product/image-list',
        component: () => import('@/components/pages/myshop/product/image_list.vue'),
    },
    {
        path: '/myshop/product/delivery',
        component: () => import('@/components/pages/myshop/product/delivery.vue'),
    },
    {
        path: '/myshop/product/contents-list',
        component: () => import('@/components/pages/myshop/product/contents_list.vue'),
    },
    {
        path: '/admin/product/contents-list',
        component: () => import('@/components/pages/myshop/product/contents_list.vue'),
    },
    {
        path: '/myshop/product/point',
        component: () => import('@/components/pages/myshop/product/point.vue'),
    },
    {
        path: '/admin/product/point',
        component: () => import('@/components/pages/myshop/product/point.vue'),
    },
    {
        path: '/myshop/product/review-point',
        component: () => import('@/components/pages/myshop/product/review_point.vue'),
    },
    {
        path: '/admin/product/review_point',
        component: () => import('@/components/pages/myshop/product/review_point.vue'),
    },
    // 도매매 API
    {
        path: '/myshop/product/domae_api',
        component: () => import('@/components/pages/myshop/product/domae_api.vue'),
    },
    {
        path: '/admin/product/domae_api',
        component: () => import('@/components/pages/myshop/product/domae_api.vue'),
    },
    {
        path: '/myshop/page/create',
        component: () => import('@/components/pages/myshop/page/create.vue'),
    },
    // 주문 관리
    {
        path: '/myshop/order/list',
        component: () => import('@/components/pages/myshop/order/list.vue'),
    },
    {
        path: '/myshop/order/view',
        component: () => import('@/components/pages/myshop/order/view.vue'),
    },
    {
        path: '/myshop/order/finalized',
        component: () => import('@/components/pages/myshop/order/finalized.vue'),
    },
    {
        path: '/myshop/order/product_summary',
        component: () => import('@/components/pages/myshop/order/product_summary.vue'),
    },
    {
        path: '/admin/order/product_summary',
        component: () => import('@/components/pages/myshop/order/product_summary.vue'),
    },
    {
        path: '/myshop/order/vat',
        component: () => import('@/components/pages/myshop/order/vat.vue'),
    },
    {
        path: '/admin/order/vat',
        component: () => import('@/components/pages/myshop/order/vat.vue'),
    },
    // 회원 관리
    {
        path: '/myshop/member/list',
        component: () => import('@/components/pages/myshop/member/list.vue'),
    },
    {
        path: '/myshop/member/point',
        component: () => import('@/components/pages/myshop/member/point.vue'),
    },
    {
        path: '/myshop/member/pending',
        component: () => import('@/components/pages/myshop/member/pending.vue'),
    },
    // 쿠폰 관리
    {
        path: '/myshop/coupon/list',
        component: () => import('@/components/pages/myshop/coupon/list.vue'),
    },
    {
        path: '/myshop/coupon/create',
        component: () => import('@/components/pages/myshop/coupon/create.vue'),
    },
    // 포인트 관리
    {
        path: '/myshop/point/list',
        component: () => import('@/components/pages/myshop/point/list.vue'),
    },
    // 디자인 관리
    {
        path: '/myshop/design/mainpage',
        component: () => import('@/components/pages/myshop/design/mainpage.vue'),
    },
    {
        path: '/myshop/design/kv',
        component: () => import('@/components/pages/myshop/design/kv.vue'),
    },
    {
        path: '/admin/kv',
        component: () => import('@/components/pages/myshop/design/kv.vue'),
    },
    {
        path: '/myshop/design/skin',
        component: () => import('@/components/pages/myshop/design/skin.vue'),
    },
    {
        path: '/myshop/design/list',
        component: () => import('@/components/pages/myshop/design/list.vue'),
    },
    // 팝업 관리
    {
        path: '/myshop/popup',
        component: () => import('@/components/pages/myshop/popup/list.vue'),
    },
    {
        path: '/admin/popup',
        component: () => import('@/components/pages/myshop/popup/list.vue'),
    },
    // 페이지/콘텐츠 관리
    {
        path: '/myshop/page/list',
        component: () => import('@/components/pages/myshop/page/list.vue'),
    },
    {
        path: '/myshop/page/create',
        component: () => import('@/components/pages/myshop/page/create.vue'),
    },
    // 이미지 관리
    {
        path: '/myshop/image/list',
        component: () => import('@/components/pages/myshop/image/list.vue'),
    },
    {
        path: '/myshop/image/create',
        component: () => import('@/components/pages/myshop/image/create.vue'),
    },
    // 공지사항
    {
        path: '/myshop/notice/list',
        component: () => import('@/components/pages/myshop/notice/list.vue'),
    },
    {
        path: '/admin/notice',
        component: () => import('@/components/pages/myshop/notice/list.vue'),
    },
    {
        path: '/admin/notice/view',
        component: () => import('@/components/pages/myshop/notice/view.vue'),
    },
    // 마이샵 관리자에서 연 공지 — /admin/... 로 가면 메뉴가 다른 관리자(QRO)로 바뀌었다
    {
        path: '/myshop/notice/view',
        component: () => import('@/components/pages/myshop/notice/view.vue'),
    },
    // Q&A 관리
    {
        path: '/myshop/qna/list',
        component: () => import('@/components/pages/myshop/qna/list.vue'),
    },
    {
        path: '/admin/qna/list',
        component: () => import('@/components/pages/myshop/qna/list.vue'),
    },
    // 리뷰 관리
    {
        path: '/myshop/review/list',
        component: () => import('@/components/pages/myshop/review/list.vue'),
    },
    {
        path: '/admin/review/list',
        component: () => import('@/components/pages/myshop/review/list.vue'),
    },
    // 성과 리포트
    {
        path: '/myshop/performance',
        component: () => import('@/components/pages/myshop/performance/index.vue'),
    },
    {
        path: '/admin/performance',
        component: () => import('@/components/pages/myshop/performance/index.vue'),
    },
    // 설정
    {
        path: '/myshop/setting',
        component: () => import('@/components/pages/myshop/setting/index.vue'),
    },
    {
        path: '/admin/setting',
        component: () => import('@/components/pages/myshop/setting/index.vue'),
    },
    // 커스텀 스크립트
    {
        path: '/myshop/setting/script',
        component: () => import('@/components/pages/myshop/setting/script.vue'),
    },
    {
        path: '/admin/script',
        component: () => import('@/components/pages/myshop/setting/script.vue'),
    },
    // 사업자 정보
    {
        path: '/myshop/setting/corp',
        component: () => import('@/components/pages/myshop/setting/corp.vue'),
    },
    {
        path: '/admin/corp',
        component: () => import('@/components/pages/myshop/setting/corp.vue'),
    },
    // 사업자 정보 변경 요청
    {
        path: '/myshop/setting/corp/change',
        component: () => import('@/components/pages/myshop/setting/corp_change_request.vue'),
    },
    {
        path: '/admin/corp/change',
        component: () => import('@/components/pages/myshop/setting/corp_change_request.vue'),
    },
    // 교환/반품 정책
    {
        path: '/myshop/setting/refund_rules',
        component: () => import('@/components/pages/myshop/setting/refund_rules.vue'),
    },
    {
        path: '/admin/refund_rules',
        component: () => import('@/components/pages/myshop/setting/refund_rules.vue'),
    },

    // ============================================
    // 개발자 테스트 페이지 (인증 불필요)
    // ============================================
    {
        path: '/test',
        component: () => import('@/components/pages/test/index.vue'),
    },

    {
        path: "/404",
        name: "notFound",
        component: NotFound,
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/404",
    },
    //]
]

/*
const router = new VueRouter({
    mode: 'history',
    routes: routes
})
*/


const router = createRouter({
    //history: createWebHistory(process.env.BASE_URL),
    //mode:'history',

    history: createWebHistory(),
    routes
})


router.beforeEach(async (to, from, next) => {
    // /test 페이지는 인증 없이 바로 진입 (가장 먼저 체크)
    if (to.path === '/test' || to.path.startsWith('/test/')) {
        store.commit('hide_menu', true)
        next()
        return
    }

    // 관리자 타입 설정 (QRO / MYSHOP)
    const adminType = getAdminTypeFromPath(to.path)
    store.commit('admin_type', adminType)

    //console.log(to)
    if(to.query.token) {
        store.commit('login_token', to.query.token)
    }

    {
        let getCookie2 = function(name) {
            var i, x, y, ARRcookies = document.cookie.split(";");
            for (i = 0; i < ARRcookies.length; i++) {
                x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
                y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
                x = x.replace(/^\s+|\s+$/g, "");
                if (x == name) {
                    return unescape(y);
                }
            }
        }

        let setCookie2 = function (name, value, mins) {
            if (mins) {
                var date = new Date();
                date.setTime(date.getTime() + (mins * 60 * 1000));
                var expires = "; expires=" + date.toGMTString();
            } else {
                var expires = "";
            }
            document.cookie = name + "=" + value + expires + "; path=/";
        }

        let sid = getCookie2('APP-SID')
        let skey = getCookie2('APP-SKEY')

        //sid
        if(sid != null && skey != null) {
            // 그냥 쿠키로 쓴다
            setCookie2('sid', sid)
            setCookie2('skey', skey)
            //store.commit('sid', {value:sid})
            //store.commit('skey', {value:skey})
        }
    }


    var host = location.host
    if (host.indexOf('admin-ex.shockping.com') >= 0) {
        var req = new XMLHttpRequest();
        req.open('GET', document.location, false);
        req.send(null);
        var headers = req.getAllResponseHeaders().toLowerCase();
        //console.log(headers)


        var getCookie = function(cookieName){
            var cookieValue=null;
            if(document.cookie){
                var array=document.cookie.split((escape(cookieName)+'='));
                if(array.length >= 2){
                    var arraySub=array[1].split(';');
                    cookieValue=unescape(arraySub[0]);
                }
            }
            return cookieValue;
        }


        var kid = getCookie('kid')
        var kpw = getCookie('kpw')
        var kpw2 = getCookie('kpw2')

        // 키오스크 계정으로 로그인
        var url2 = '/api/offline/init/session?kid=' +
            kid + '&kpw=' + kpw + '&kpw2=' + kpw2

        if(!kid || !kpw || !kpw2) {
            return
        }


        await axios.get(url2)
            .then(data => {
                // 로그인 세션을 쓴다
                let url = process.env.VUE_APP_ADMIN_URL+to.fullPath
                location.href = url
                return

            }).catch(err => {
                //console.log(err.data)
                //alert('error')
                //console.log(err)
                next('/404')
                //location.href = 'https://admin2.shockping.com/404'
            // false
        })

        return
    }


    if ( to.path.startsWith('/user') || to.fullPath.indexOf('/sub-login') >= 0 || to.fullPath.indexOf('/odist/login') >= 0 || to.fullPath.indexOf('/checkout') >= 0 || to.fullPath.indexOf('/embed') >= 0   || to.fullPath.indexOf('/_embed') >= 0  || to.fullPath.indexOf('/images') >= 0  || to.fullPath.indexOf('/ext') >= 0  || to.fullPath.indexOf('/admin/e_mod') >= 0 || to.query.embed === 'true' ) {
        // hide_menu
        store.commit('hide_menu', true)
    } else {
        store.commit('hide_menu', false)
    }

    // 마스터 어드민
    if(needsExtraAuth(to))
    {
        const token = getSessionToken();
        if (!token) {

            // 세션 없음 → 로그인으로
            next({
                path: '/user/master-login',
                query: { redirect: to.fullPath }, // 로그인 후 원래 위치로 복귀용(선택)
                replace: true,
            });
            return
        }

        // 세션 밸리드 확인
        let url = '/core-api/user/check/login-master'
        await axios.get(url)
            .then(data => {
                // ok
                let session = data.data
                checkFilter(to.fullPath, session)

            }).catch(err => {
                next({
                    path: '/user/master-login',
                    query: { redirect: to.fullPath }, // 로그인 후 원래 위치로 복귀용(선택)
                    replace: true,
                });
                return
            })


        if (isSessionExpired()) {
            // 비활동 20분 초과 → 세션 종료 후 로그인으로
            clearSession();
            next( {
                path: '/user/master-login',
                query: { redirect: to.fullPath, reason: 'expired' },
                replace: true,
            });
        }

        // 정상: 활동시간 갱신(슬라이딩 만료)
        touchSession();
    }


    // /user 페이지는 권한 체크 없이 바로 진행 (로그인/가입 페이지)
    // (/test는 함수 시작 부분에서 이미 처리됨)
    if (to.path.startsWith('/user') || to.fullPath.indexOf('/sub-login') >= 0 || to.fullPath.indexOf('/odist/login') >= 0) {
        next()
        return
    }

    // userinfo 권한 체크 수행
    // (master-admin은 위에서 needsExtraAuth로 추가 IP/세션 체크 완료)
    if ( (to.fullPath.indexOf('/master-admin') >= 0 || to.fullPath.indexOf('/admin') >= 0 && to.fullPath.indexOf('/login') < 0) || to.fullPath.indexOf('/table/grid') >= 0
        || to.fullPath.indexOf('/user/auth') >= 0
        || to.fullPath.indexOf('/embed') >= 0
        || to.fullPath.indexOf('/myshop') >= 0
        || to.path === '/ext/erp'
        || to.path.startsWith('/erp/')
    ) {

        if (store.state.login != 1) {

            // token?
            let url = '/core-api/user/userinfo'
            if(to.query.token) {
                url += '?token=' + to.query.token
            }
            await axios.get(url)
                .then(async data => {
                    let a = data.data
                    //console.log(a)
                    if(a.uid==67) {
                        store.commit('uid', a.uid)
                        store.commit('admin', true)
                    }
                    else if(to.fullPath.indexOf('/master-admin') >= 0) {
                        // error
                        next('/404')
                        return
                    }

                    {
                        // agency_sid/agency_skey 쿠키 확인
                        const cookies = document.cookie.split(';').reduce((acc, c) => {
                            const [k, v] = c.trim().split('=')
                            acc[k] = v
                            return acc
                        }, {})

                        if(a.agency) {
                            store.commit('uid', a.uid)
                            store.commit('agency', true)

                            // agency_sid/agency_skey 쿠키가 없거나 현재 sid와 다르면 저장 (마스터 계정 정보 갱신)
                            const sid = cookies['sid']
                            const skey = cookies['skey']
                            if (sid && skey) {
                                if (cookies['agency_sid'] !== sid || cookies['agency_skey'] !== skey) {
                                    const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString()
                                    document.cookie = `agency_sid=${sid}; expires=${expires}; path=/`
                                    document.cookie = `agency_skey=${skey}; expires=${expires}; path=/`
                                }
                            }
                        }
                        // 서브계정 전환 상태: agency 쿠키가 있지만 API 응답에 agency가 없는 경우
                        else if (cookies['agency_sid'] && cookies['agency_skey']) {
                            // 현재 sid가 agency_sid와 같다면, 이 계정은 agency가 아닌 것이 확실함
                            // (switched 상태라면 sid !== agency_sid 여야 함)
                            if (cookies['sid'] && cookies['sid'] === cookies['agency_sid']) {
                                store.commit('agency', false)
                                // 잘못된 agency 쿠키 삭제
                                document.cookie = `agency_sid=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`
                                document.cookie = `agency_skey=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`
                            } else {
                                // API에서 false인 경우, 우선 false로 처리하여 일반 메뉴 노출
                                // App.vue의 loadSubAccounts에서 실제 유효성 검증 후 성공하면 true로 전환함
                                store.commit('agency', false)
                            }
                        }
                        else {
                            // agency도 아니고 agency 쿠키도 없으면 확실히 false
                            store.commit('agency', false)
                        }
                    }


                    if (a.uid) {
                        store.commit('login', 1)
                        store.commit('login_data', a)
                        store.commit('uid', a.uid)

                        if (a.is_subuser) {
                            store.commit('is_subuser', true)
                            if (a.sub_permissions) {
                                store.commit('sub_permissions', typeof a.sub_permissions === 'string' ? JSON.parse(a.sub_permissions) : a.sub_permissions)
                            }
                        }

                        {
                            url = "/core-api/main/get/offline_info/smartorder?uid="+a.uid
                            axios.get(url).then(res => {
                                let clr_info = res.data.sale_ref

                            if(to.fullPath.indexOf('/riders/') >= 0) {
                                let ainfo = JSON.parse(clr_info)
                                if(!ainfo.delivery_agency) {
                                    location.href='/admin/prod/list'
                                    return
                                }
                            }

                                try {
                                    clr_info = JSON.parse(clr_info)
                                    clr_info = clr_info["color"]
                                    if(clr_info) {
                                        // set
                                        store.commit('clr_info', clr_info)
                                    }

                                } catch (e) {
                                }

                            })
                        }

                        if (store.state.is_subuser && odistSubPerm(store)) {
                            // odist 직원계정: 페이지 키(read/write) 기준. erp 의 allowed_paths 와 별개.
                            const acc = odistPathAccess(store, to.fullPath)
                            if (!acc.allowed) {
                                const first = odistFirstAllowedPath(store, !!a.agency)
                                alert('접근 권한이 없습니다.')
                                if (first && first !== to.fullPath.split('?')[0]) next(first)
                                else next(false)
                                return
                            }
                            next()
                            return
                        }

                        if (store.state.is_subuser) {
                            const paths = store.state.sub_permissions && store.state.sub_permissions.allowed_paths
                            if (!paths || paths.length === 0) {
                                alert('접근 권한이 없습니다.');
                                next(false);
                                return;
                            }
                            const target = to.fullPath.split('?')[0]
                            // /admin 루트 접근 시 허용된 첫 경로로 리다이렉트
                            if (target === '/admin' || target === '/') {
                                next(paths[0]);
                                return;
                            }
                            let allowed = paths.some(p => target === p || target.startsWith(p + '/'));
                            if (!allowed && target !== '/sub-login' && target !== '/ext/erp') {
                                alert('접근 권한이 없습니다.');
                                next(paths[0]);
                                return;
                            }
                        }

                        // erp filter 로딩 (login_data 설정 후)
                        if (to.fullPath.indexOf('/erp') >= 0 && !store.state.filter_list) {
                            let filterUrl = '/erp-api/erp/item/filter'
                            if (to.query.token) filterUrl += '?token=' + to.query.token
                            try {
                                const filterRes = await axios.get(filterUrl, { headers: { uid: store.state.login_data?.uid || '' } })
                                let v = {}
                                filterRes.data.filter_list.forEach(item => {
                                    v[item.filter_code] = item.filter_option
                                })
                                store.commit('filter_list', v)
                            } catch (err) {
                                if (err.response && err.response.status === 401) {
                                    location.href = loginPageUrl(to.fullPath)
                                    return
                                }
                            }
                        }

                        next();
                    } else {
                        throw 'e'
                    }
                }).catch(err => {
                    // 로그인 실패
                    //next('/auth?p='+encodeURIComponent(to.fullPath))
                    location.href = loginPageUrl(to.fullPath)
                    return
                    //console.log(encodeURIComponent(to.fullPath))
                })
        } else {
            if (store.state.is_subuser && odistSubPerm(store)) {
                const acc = odistPathAccess(store, to.fullPath)
                if (!acc.allowed && !to.fullPath.startsWith('/odist/login')) {
                    alert('접근 권한이 없습니다.')
                    next(false)
                    return
                }
            }
            else if (store.state.is_subuser && store.state.sub_permissions && store.state.sub_permissions.allowed_paths) {
                let allowed = store.state.sub_permissions.allowed_paths.some(p => to.fullPath.startsWith(p));
                if (!allowed && to.fullPath !== '/admin/login' && to.fullPath !== '/' && !to.fullPath.startsWith('/ext/erp')) {
                    alert('접근 권한이 없습니다.');
                    next(false);
                    return;
                }
            }
            // erp filter 로딩 (이미 로그인된 상태)
            if (to.fullPath.indexOf('/erp') >= 0 && !store.state.filter_list) {
                let filterUrl = '/erp-api/erp/item/filter'
                if (to.query.token) filterUrl += '?token=' + to.query.token
                try {
                    const filterRes = await axios.get(filterUrl, { headers: { uid: store.state.login_data?.uid || '' } })
                    let v = {}
                    filterRes.data.filter_list.forEach(item => {
                        v[item.filter_code] = item.filter_option
                    })
                    store.commit('filter_list', v)
                } catch (err) {
                    if (err.response && err.response.status === 401) {
                        location.href = loginPageUrl(to.fullPath)
                        return
                    }
                }
            }
            next()
        }
    } else {
        next()
    }
})


export default router
